import { createElement } from "react";

import { toast as sonner } from "sonner";
import type { NotifyToastOptions } from "@/types/notify.types";
import { NOTIFY_VARIANT_TOKENS } from "./tokens";

export function toastFn(opts: NotifyToastOptions) {
  const spec = NOTIFY_VARIANT_TOKENS[opts.variant];
  const Icon = spec.icon;
  return sonner(opts.title, {
    description: opts.description,
    duration: opts.duration,
    dismissible: opts.dismissible,
    action: opts.action ? { label: opts.action.label, onClick: opts.action.onClick } : undefined,
    icon: createElement(Icon, { className: spec.accentClass }),
    className: `${spec.bgClass} ${spec.borderClass}`,
  });
}

export interface SavedWithUndoOptions {
  description?: string;
  onUndo: () => void;
  duration?: number;
}

export function toastSavedWithUndo(opts: SavedWithUndoOptions): void {
  toastFn({
    variant: "success",
    title: "Salvo",
    description: opts.description ?? "há instantes",
    duration: opts.duration ?? 5000,
    action: { label: "Desfazer", onClick: opts.onUndo },
  });
}
